<script>
import Layout from '@layouts/main'
import api from '@utils/api'
import formatDate, { convertToUTC } from '@utils/format-date-with-time'
import Filters from '@views/filters-dialog'
import eventsModel from '@src/models/events'
import TablePaginator from '@components/paginator'
import Parameters from './parameters'
import { mapState } from 'vuex'
import moment from 'moment'
import { convertTemperature, toCelcius, convertBatteryCharge } from '@utils/converter'
import $ from 'jquery'
import userHasRoles from '@utils/userPermissions'
import AdjustColumnsDialog from '@components/adjust-columns-dialog'
import { hideValues, updateColumns } from '@utils/helpers/columns'

export default {
  name: 'Events',
  components: {
    Layout,
    Filters,
    TablePaginator,
    Parameters,
    AdjustColumnsDialog,
  },
  data() {
    return {
      modelName: 'events',
      showDialog: false,
      isLoading: false,
      allowedRolesToSeeDetails: [
        'SUPERUSER',
        'DICTIONARIES_OPERATOR',
        'DOCUMENTS_OPERATOR',
        'GUEST',
      ],
      headers: [
        { text: 'id', value: 'id', sortable: true },
        {
          text: 'transmitterGuid',
          value: 'transmitterId',
          sortable: true,
          show: true,
        },
        { text: 'plugGuid', value: 'plugId', sortable: true },
        { text: 'sigfoxId', value: 'sigfoxId', sortable: true, show: true },
        { text: 'zigbeeId', value: 'zigbeeId', sortable: true, show: true },
        {
          text: 'measureTime',
          value: 'measureTime',
          sortable: true,
          show: true,
        },
        {
          text: 'receiveTime',
          value: 'receiveTime',
          sortable: true,
          show: true,
        },
        { text: 'sigfoxTime', value: 'sigfoxTime', sortable: true, show: true },
        {
          text: 'sigfoxSeqNumber',
          value: 'sigfoxSeqNumber',
          sortable: true,
          show: true,
        },
        {
          text: 'sigfoxDeviceTypeId',
          value: 'sigfoxDeviceTypeId',
          sortable: true,
          show: true,
        },
        { text: 'level', value: 'level', sortable: true, show: true },
        {
          text: 'temperature',
          value: 'temperature',
          sortable: true,
          show: true,
        },
        { text: 'angleX', value: 'angleX', sortable: true, show: true },
        { text: 'angleY', value: 'angleY', sortable: true, show: true },
        {
          text: 'inclination_angle',
          value: 'inclinationAngle',
          sortable: true,
          show: true,
        },
        { text: 'rectXstart', value: 'rectXstart', sortable: true, show: true },
        { text: 'rectYstart', value: 'rectYstart', sortable: true, show: true },
        {
          text: 'calculated_angles_correction',
          value: 'calculatedAnglesCorr',
          sortable: true,
          show: true,
        },
        {
          text: 'calculated_volume_correction',
          value: 'calculatedVolumeCorr',
          sortable: true,
          show: true,
        },
        {
          text: 'calculation_comment',
          value: 'comment',
          sortable: true,
          show: true,
        },
        { text: 'remain_id', value: 'remainId', sortable: true, show: true },
        {
          text: 'battaryCharge',
          value: 'batteryCharge',
          sortable: true,
          show: true,
        },
        {
          text: 'wakeupReason',
          value: 'wakeupReason',
          sortable: true,
          show: true,
        },
        {
          text: 'measureType',
          value: 'measureType',
          sortable: true,
          show: true,
        },
        {
          text: 'corrections',
          value: 'corrections',
          sortable: true,
          show: true,
        },
        { text: 'sending', value: 'sending', sortable: true, show: true },
      ],
      rowsPerPage: [25, 50, 100],
      page: 1,
      totalPages: 0,
      sortBy: 'receiveTime',
      descending: true,
      first: false,
      last: false,
      content: [],
      pagination: {},
      totalElements: 0,
      showFilters: false,
      model: eventsModel,
      filters: null,
      dateRangeParams: {},
    }
  },
  computed: {
    params() {
      return {
        size: this.pagination.rowsPerPage || null,
        page: this.page || null,
        sort_property: this.sortBy || null,
        sort_direction: this.descending || null,
        ...this.filters,
        ...this.dateRangeParams,
      }
    },
    ...mapState({
      unitsMeasurementValue: state => state.userSettings.userSettings['unitsMeasurement'],
    }),
    unitsMeasurement() {
      return this.$store.getters['userSettings/getUnitsMeasurement']
    },
    userAllowedToNavigate() {
      return userHasRoles(
        this.$store.state.auth.userRole,
        this.allowedRolesToSeeDetails
      )
    },
  },
  watch: {
    pagination: {
      handler() {
        this.$store.commit('pagination/SET', {
          name: this.modelName,
          pagination: {
            page: this.page,
            rowsPerPage: this.pagination.rowsPerPage,
            sortBy: this.sortBy,
            descending: this.descending,
          },
        })
      },
      deep: true,
    },
  },
  updated() {
    this.updateScrollBar()
  },
  mounted() {
    let scrollWrapper = $('.scroll-wrapper')
    let fixedHeaderTable = $('.fixed-header-table').find('.table__overflow')
    fixedHeaderTable.scroll(function() {
      scrollWrapper.scrollLeft(fixedHeaderTable.scrollLeft())
    })
    scrollWrapper.scroll(function() {
      fixedHeaderTable.scrollLeft(scrollWrapper.scrollLeft())
    })
    window.addEventListener('resize', this.updateScrollBar)
  },
  destroyed() {
    window.removeEventListener('resize', this.updateScrollBar)
  },
  methods: {
    updateScrollBar() {
      let fixedHeaderTable = $('.fixed-header-table')
      $('.scroll-inner')
        .width(fixedHeaderTable.find('.datatable')[0].scrollWidth)
        .height(20)
      $('.scroll-wrapper').width(
        fixedHeaderTable.find('.table__overflow').width() - 5
      )
    },
    setParams(value) {
      this.dateRangeParams = { ...value }
      this.getPaginator()
      if (value.clicked) {
        this.page = 1
        this.pagination.page = 1
      }
      this.getFilters()
      this.fetchData()
    },
    fetchData() {
      this.prepareParams()
      this.convertDateParamsToFilters()
      this.isLoading = true
      api
        .getItems('event/v2', this.convertUnitMeasurements(this.params))
        .then(response => {
          this.content = response.content
          this.totalPages = response.totalPages
          this.first = response.first
          this.last = response.last
          this.page = response.number + 1
          this.pagination = {
            ...this.pagination,
            page: 1,
            rowsPerPage: response.size,
            sortBy: this.sortBy,
            descending: this.descending,
          }
        })
        .catch(() => {})
        .then(() => {
          this.isLoading = false
        })
    },
    convertDateParamsToFilters() {
      Object.keys(this.params).forEach(key => {
        if (key === 'selected_time') {
          this.params[`filter_${this.params.selected_time.code}_value`] =
            convertToUTC(this.params.start_date) +
            '|' +
            convertToUTC(this.params.end_date)
          this.params[`filter_${this.params.selected_time.code}_comparison`] =
            'BETWEEN'
          delete this.params.start_date
          delete this.params.end_date
          delete this.params.selected_time
        }
      })
    },
    convertUnitMeasurements(params) {
      let convertedParams = { ...params }
      if (convertedParams['filter_level_value']) {
        convertedParams['filter_level_value'] = (
          convertedParams['filter_level_value'] *
          this.unitsMeasurement.lengthMultiplier
        ).toFixed(2)
      }
      if (
        convertedParams['filter_temperature_value'] &&
        this.unitsMeasurementValue === 'us'
      ) {
        convertedParams['filter_temperature_value'] = toCelcius(
          convertedParams['filter_temperature_value']
        )
      }
      return convertedParams
    },
    getValue(dictionaryName, value) {
      return this.$store.getters['data/getValueFromDictionary'](
        dictionaryName,
        value
      )
    },
    prepareParams() {
      if (!this.params.useStartDateTime) {
        let now = moment(new Date())
        this.params.start_date = convertToUTC(now.subtract(150, 'years'))
        delete this.params.start_time
      }
      if (!this.params.useEndDateTime) {
        this.params.end_date = convertToUTC(
          moment(new Date()).add(200, 'years')
        )
        delete this.params.end_time
      }
      if (
        this.params &&
        this.params.start_date !== '' &&
        this.params.useStartDateTime
      ) {
        this.params.start_date =
          this.params.start_date + ' ' + this.params.start_time
        delete this.params.start_time
      }
      if (
        this.params &&
        this.params.end_date !== '' &&
        this.params.useEndDateTime
      ) {
        this.params.end_date = this.params.end_date =
          this.params.end_date + ' ' + this.params.end_time
        delete this.params.end_time
      }
    },
    getMilliseconds(time) {
      const milliseconds = (h, m) => (h * 60 * 60 + m * 60) * 1000
      const timeParts = time.split(':')
      return milliseconds(timeParts[0], timeParts[1])
    },
    getVolume(volume) {
      if (volume && volume > 0) {
        const vol = (volume / this.unitsMeasurement.volumeMultiplier).toFixed(2)
        return vol
          .toString()
          .concat(
            this.unitsMeasurement.volumeMeasure === 'liters' ? 'L' : 'gal'
          )
      }
    },
    getFilters() {
      this.fetchFilters()
    },
    fetchFilters() {
      const filter = this.$store.getters['filters/getFilters'](this.modelName)
      this.filters = filter ? filter.value : null
      this.showFilters = false
    },
    setFilters() {
      this.fetchFilters()
      this.page = 1
      this.fetchData()
    },
    getPaginator() {
      const pagination = this.$store.getters['pagination/get'](this.modelName)
      if (pagination) {
        this.page = pagination.page || 1
        this.sortBy = pagination.sortBy || this.sortBy
        this.descending = pagination.descending || false
        this.pagination.page = 1
        this.pagination.rowsPerPage = pagination.rowsPerPage || 10
      } else {
        this.page = 1
        this.pagination.page = 1
        this.pagination.rowsPerPage = 10
      }
    },
    changePage(value) {
      this.page = value
      this.fetchData()
    },
    changeRowsPerPage(value) {
      if (this.pagination.rowsPerPage === value) return
      this.pagination = {
        ...this.pagination,
        rowsPerPage: value,
      }
      this.page = 1
      this.$store.dispatch('pagination/saveRowsPerPage', value)
      this.fetchData()
    },
    changeSort(header) {
      if (!header.sortable) return
      if (this.sortBy === header.value) {
        this.descending = !this.descending
      } else {
        this.sortBy = header.value
        this.descending = false
      }
      this.fetchData()
    },
    getSortClass(header) {
      return [
        header.sortable ? 'column sortable' : null,
        this.pagination.descending ? 'desc' : 'asc',
        header.value === this.pagination.sortBy ? 'active' : '',
      ]
    },
    headerToWrap(header) {
      return (
        header.text.includes('rectXstart') ||
        header.text.includes('rectYstart') ||
        header.text.includes('battaryCharge') ||
        header.text.includes('corr_rep') ||
        header.text.includes('wakeupReason') ||
        header.text.includes('measureType') ||
        header.text.includes('calculate') ||
        header.text.includes('inclination_angle')
      )
      // return false;
    },
    getHeaderAlign(header) {
      if (this.headerToWrap(header)) {
        let styleResult = {
          'white-space': 'pre-line',
          display: 'inline-block',
        }
        if (header.text.includes('calculate')) {
          styleResult = { ...styleResult, 'min-width': '95px' }
        }
        return styleResult
      }
      return {}
    },
    getIconCentered(header) {
      return this.headerToWrap(header) ? { 'vertical-align': 'super' } : {}
    },
    justifyPadding(header) {
      if (header.show === false) {
        return { display: 'none' }
      }
      return this.headerToWrap(header)
        ? {
            'text-align': 'left',
            'padding-left': '8px',
            'padding-right': '12px',
          }
        : {
            'text-align': 'left',
            'padding-left': '8px',
            'padding-right': '8px',
          }
    },
    dateFormat(date) {
      const formatedDate = formatDate(date)
      return formatedDate === 'Invalid Date' ? '' : formatedDate
    },
    convertLevel(value) {
      let number = value / this.unitsMeasurement.lengthMultiplier
      return (
        number.toFixed(2) +
        (this.unitsMeasurement.lengthMeasure === 'inches' ? '"' : ' mm')
      )
    },
    isNull(value) {
      return value === null || value === undefined
    },
    roundValue(value) {
      return value ? value.toFixed(1) : ''
    },
    convertTemperature(value) {
      return convertTemperature(value, this.unitsMeasurementValue)
    },
    convertBatteryCharge(value) {
      return convertBatteryCharge(value, this.$store.getters['userSettings/get']('batteryChargeDisplay'))
    },
    refresh() {
      this.$refs.paramsRef.confirm(true)
    },
    hideValues(field) {
      return hideValues(field, this.headers)
    },
    updateColumns(columns) {
      updateColumns(columns, this.headers)
    },
    openDialog() {
      this.showDialog = true
    },
  },
}
</script>

<template>
  <Layout>
    <div slot="actionButton">
      <v-btn 
        color="info" 
        @click="refresh">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-btn 
        :color="filters && Object.keys(filters).length !== 0 ? `success` : `info`"
        @click="showFilters = true">
        <v-icon>filter_list</v-icon>
      </v-btn>
    </div>
    <parameters 
      ref="paramsRef"
      @set-params="setParams($event)"
    />
    <div 
      v-show="content.length > 0"
      class="scroll-wrapper">
      <div class="scroll-inner"/>
    </div>
    <v-layout justify-end>
      <v-btn
        icon
        flat
        @click="openDialog()">
        <v-icon>view_column</v-icon>
      </v-btn>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="content"
      :pagination="pagination"
      :total-items="totalElements"
      :loading="isLoading"
      class="fixed-header-table"
      hide-actions
    >
      <template
        slot="headers"
        slot-scope="props">
        <tr>
          <th
            v-for="header in headers"
            :key="header.text"
            :class="getSortClass(header)"
            :style="justifyPadding(header)"
            @click="changeSort(header)"
          >
            <span
              :style="getHeaderAlign(header)"
            > {{ $t(`label__${header.text}`) }} </span>
            <v-icon
              v-if="header.sortable"
              :style="getIconCentered(header)"
              small>expand_less</v-icon>
          </th>
        </tr>
      </template>
      <v-progress-linear
        slot="progress"
        height="2"
        color="blue"
        background-color="#E0E0E0"
        indeterminate
      />
      <template 
        slot="items" 
        slot-scope="props">
        <tr>
          <td :class="$style.oneRowPadding">{{ props.item.id }}</td>
          <td 
            v-if="!hideValues('transmitterId')" 
            class="text-center">
            <router-link
              v-if="props.item.transmitterId && props.item.transmitterId !=='0' && userAllowedToNavigate"
              :to="{ name: 'searchPlug', params: { serial: props.item.transmitterId , goodsGroup: 3 }}"> {{ props.item.transmitterId }}
            </router-link>
            <span v-if="props.item.transmitterId && props.item.transmitterId !=='0' && !userAllowedToNavigate">{{ props.item.transmitterId }}</span>
            <div v-if="props.item.transmitterId==='0'"/>
          </td>
          <td :class="$style.oneRowPadding">
            <router-link
              v-if="props.item.plugId && props.item.plugId!=='0' && userAllowedToNavigate"
              :to="{ name: 'searchPlug', params: { serial: props.item.plugId, goodsGroup: 2 }} ">
              {{ props.item.plugId }}
            </router-link>
            <span v-if="props.item.plugId && props.item.plugId!=='0' && !userAllowedToNavigate">
              {{ props.item.plugId }}</span>
            <div v-if="props.item.plugId==='0'"/>
          </td>
          <td 
            v-if="!hideValues('sigfoxId')"
            :class="$style.oneRowPadding" >
            <router-link
              v-if="props.item.sigfoxId && props.item.sigfoxId!=='0' && userAllowedToNavigate"
              :to="{ name: 'searchPlug', params: { serial: props.item.sigfoxId, goodsGroup: 2 }} "> {{
              props.item.sigfoxId }}
            </router-link>
            <span v-if="props.item.sigfoxId && props.item.sigfoxId!=='0' && !userAllowedToNavigate">
              {{ props.item.sigfoxId }}</span>
            <div v-if="props.item.sigfoxId==='0'"/>
          </td>
          <td v-if="!hideValues('zigbeeId')">
            <div v-if="props.item.zigbeeId==='0'"/>
            <div v-if="props.item.zigbeeId && props.item.zigbeeId!=='0'"> {{ props.item.zigbeeId }}</div>
          </td>
          <td
            v-if="!hideValues('measureTime')"
            :class="$style.oneRowPadding">{{ dateFormat(props.item.measureTime) }}</td>
          <td
            v-if="!hideValues('receiveTime')"
            :class="$style.oneRowPadding">{{ dateFormat(props.item.receiveTime) }}</td>
          <td
            v-if="!hideValues('sigfoxTime')"
            :class="$style.oneRowPadding">{{ dateFormat(props.item.sigfoxTime) }}</td>
          <td
            v-if="!hideValues('sigfoxSeqNumber')"
            :class="$style.oneRowPadding">{{ props.item.sigfoxSeqNumber }}</td>
          <td
            v-if="!hideValues('sigfoxDeviceTypeId')"
            :class="$style.oneRowPadding">{{ props.item.sigfoxDeviceTypeId }}</td>
          <td
            v-if="!hideValues('level')"
            :class="$style.oneRowPadding">{{ convertLevel(props.item.level) }}</td>
          <td
            v-if="!hideValues('temperature')">
            {{ convertTemperature(props.item.temperature) }}</td>
          <td
            v-if="!hideValues('angleX')"
            :class="$style.oneRowPadding">{{ props.item.angleX }}</td>
          <td
            v-if="!hideValues('angleY')"
            :class="$style.oneRowPadding">{{ props.item.angleY }}</td>
          <td
            v-if="!hideValues('inclinationAngle')">
            {{ roundValue(props.item.inclinationAngle) }}</td>
          <td
            v-if="!hideValues('rectXstart')">
            {{ props.item.rectXstart }}</td>
          <td
            v-if="!hideValues('rectYstart')">
            {{ props.item.rectYstart }}</td>
          <td
            v-if="!hideValues('calculatedAnglesCorr')">
            {{ getVolume(props.item.calculatedAnglesCorr) }}</td>
          <td
            v-if="!hideValues('calculatedVolumeCorr')">
            {{ getVolume(props.item.calculatedVolumeCorr) }}</td>
          <td
            v-if="!hideValues('comment')">
            {{ props.item.comment }}</td>
          <td
            v-if="!hideValues('remainId')">
            {{ props.item.remainId }}</td>
          <td
            v-if="!hideValues('batteryCharge')"
            :class="$style.wrappedRowPadding">{{ convertBatteryCharge(props.item.batteryCharge) }}</td>
          <td
            v-if="!hideValues('wakeupReason')"
            :class="$style.wrappedRowPadding">{{ getValue("wakeupReason", props.item.wakeupReason) }}</td>
          <td
            v-if="!hideValues('measureType')"
            :class="$style.wrappedRowPadding">{{ getValue ("measureType", props.item.measureType) }}</td>
          <td
            v-if="!hideValues('corrections')"
            :class="$style.oneRowPadding">{{ getValue("corrections", props.item.corrections) }}</td>
          <td
            v-if="!hideValues('sending')"
            :class="$style.oneRowPadding">{{ getValue ("sending", props.item.sending) }}</td>
        </tr>
      </template>
    </v-data-table>
    <table-paginator
      :page="page"
      :total-pages="totalPages"
      :first="first"
      :last="last"
      :rows-per-page="pagination.rowsPerPage"
      @change-page="changePage($event)"
      @change-rows-per-page="changeRowsPerPage($event)" />
    <adjust-columns-dialog
      v-model="showDialog"
      :headers="headers.filter(h => h.show !== undefined)"
      :model-name="modelName"
      @columns-updated="updateColumns"
    />
    <filters
      :visible="showFilters"
      :model="model"
      :model-name="modelName"
      @close-modal="showFilters = false"
      @filters-confirmed="setFilters()"
    />
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
.sdTable {
  border: 1px solid #dfdfdf;

  th {
    outline: none;
  }

  td {
    white-space: nowrap;
  }
}
.sdEditRow {
  cursor: pointer;
}
.sdBorder {
  border: 1px solid #dfdfdf;
  border-bottom: none;
}
.wrapText {
  white-space: pre-line;
}
.oneRowPadding {
  padding-right: 8px !important;
  padding-left: 8px !important;
}

.wrappedRowPadding {
  padding-right: 12px !important;
  padding-left: 8px !important;
}
</style>
